import { useTranslation } from 'react-i18next';
import React from 'react';
import { useIsElementOverflowing } from '../../../common/isElementOverflowingHook';
import { Button } from '@mui/material';
// Expand/Collapse button handling (when RTE is disabled)
export var useExpandCollapse = function (disabled) {
    var t = useTranslation().t;
    var _a = React.useState(false), isExpanded = _a[0], setIsExpanded = _a[1];
    var _b = useIsElementOverflowing(), editorWrapperReference = _b[0], isContentOverflowing = _b[1];
    var expandCollapseButton = isContentOverflowing && disabled ? (React.createElement("div", { className: 'RichEditor-expandCollapseButtonWrapper' },
        React.createElement(Button, { className: 'RichEditor-expandCollapseButton', onClick: function () { return setIsExpanded(!isExpanded); } }, t(isExpanded ? 'richTextEditor.collapse' : 'richTextEditor.expand')))) : null;
    return {
        editorWrapperReference: editorWrapperReference,
        isExpanded: isExpanded,
        expandCollapseButton: expandCollapseButton,
    };
};
//# sourceMappingURL=useExpandCollapse.js.map